/**
 * Deixa na peça um encaixe para o botão do app no lugar onde estava o botão do
 * e-mail (CENTRAL-04.2.2, emendada em 2026-09-25).
 *
 * O botão do e-mail é podado — aponta para URL absoluta e, injetado, nunca vira
 * `<Link>`. Mas o lugar dele no layout é o certo: solto abaixo do cartão, o botão
 * do app parecia não pertencer ao aviso. O encaixe é um `div` vazio que o modal
 * ocupa por portal.
 *
 * O botão é o primeiro bloco marcado com `data-inapp="hide"` que contém link —
 * antes dele só vem o preheader, que não tem link; depois vêm o "copie e cole" e
 * o rodapé. Assim a regra continua ancorada no marcador do template, sem casar
 * texto. Sem bloco assim, não há encaixe e o modal põe o botão abaixo da peça.
 *
 * Roda depois do `sanitizeHtml` e ANTES do `pruneEmailChrome`, que remove o bloco.
 */
export const CTA_SLOT = 'data-inapp-slot';

export function markCtaSlot(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const botao = Array.from(doc.body.querySelectorAll('[data-inapp="hide"]')).find(node => node.querySelector('a'));
  if (!botao) return html;

  const encaixe = doc.createElement('div');
  encaixe.setAttribute(CTA_SLOT, 'cta');
  botao.before(encaixe);

  return doc.body.innerHTML;
}
